// extracted by mini-css-extract-plugin
module.exports = {"articles":"SectionRecent_articles__b9cn8","article":"SectionRecent_article__SwgLc"};